import { render, staticRenderFns } from "./PayTestModal.vue?vue&type=template&id=3b243bd0&scoped=true"
import script from "./PayTestModal.vue?vue&type=script&lang=js"
export * from "./PayTestModal.vue?vue&type=script&lang=js"
import style0 from "./PayTestModal.vue?vue&type=style&index=0&id=3b243bd0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b243bd0",
  null
  
)

export default component.exports